import script from "./AdminConfigBranches.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminConfigBranches.vue?vue&type=script&lang=ts&setup=true"

import "./AdminConfigBranches.vue?vue&type=style&index=0&id=27fae3e4&lang=scss"

const __exports__ = script;

export default __exports__